import React, { forwardRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Eraser, PenLine } from 'lucide-react';
import { Label } from '../../../components/ui/label';

// Campo de assinatura (canvas) com rótulo e botão limpar. ref = SignatureCanvas (isEmpty / getCanvas / clear).
export const SignaturePad = forwardRef(({ label, clearLabel, testId, height = 176 }, ref) => (
  <div>
    <div className="flex items-center justify-between mb-1">
      <Label className="text-xs font-semibold text-slate-600 flex items-center gap-1"><PenLine className="h-3.5 w-3.5 text-teal-700" /> {label}</Label>
      <button type="button" onClick={() => ref?.current?.clear()} className="inline-flex items-center gap-1 text-[11px] font-semibold text-teal-700 hover:underline" data-testid={`${testId}-clear`}><Eraser className="h-3.5 w-3.5" /> {clearLabel}</button>
    </div>
    <div className="rounded-2xl border-2 border-dashed border-teal-300 bg-white shadow-inner overflow-hidden" data-testid={testId}>
      <SignatureCanvas ref={ref} penColor="#0F172A" canvasProps={{ className: 'w-full touch-none', style: { width: '100%', height: `${height}px` } }} />
    </div>
  </div>
));
SignaturePad.displayName = 'SignaturePad';

export const padPng = (ref) => (ref?.current && !ref.current.isEmpty() ? ref.current.getCanvas().toDataURL('image/png') : null);
